import { Modal } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { loader } from "../../Func_genericas/loader";
import { ICustoSchema, IPlanoERPSchema } from "../../Interfaces/financeiro/financeiro";
import { Modaladdcustos } from "./add_custos";
import AddIcon from "@mui/icons-material/Add";

interface I_aux {
    list: ICustoSchema[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list: React.Dispatch<React.SetStateAction<ICustoSchema[]>>,
    obj_financeiro: IPlanoERPSchema | undefined,
    set_obj_new_financeiro: React.Dispatch<React.SetStateAction<IPlanoERPSchema | undefined>>,

}

export const Modalverlistacusto: React.FC<I_aux> = ({
    list,
    flag_open_modal,
    set_flag_open_modal,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list,
    obj_financeiro,
    set_obj_new_financeiro,

}) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);


    const [flag_open_modal_ver_mais, set_flag_open_modal_ver_mais] = useState<boolean>(false);
    const [flag_open_modal_edit, set_flag_open_modal_edit] = useState<boolean>(false);
    const [flag_open_modal_add, set_flag_open_modal_add] = useState<boolean>(false);
    const [flag_open_modal_aux, set_flag_open_modal_aux] = useState<boolean>(false);
    const [obj_new, set_obj_new] = useState<ICustoSchema>();
    const [hover, setHover] = useState<{ flag: boolean; id: number | null }>({ flag: false, id: null });

    useEffect(() => {
        (async () => {
            set_list(obj_financeiro?.custos ?? [])
        })();
    }, []);



    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    Detalhes do Plano ERP
                </h2>
                <button
                    type="button"
                    onClick={() => {
                        set_flag_open_modal(false)
                        set_flag_open_modal_ver_mais(false)
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>


            {
                flag_open_modal_aux === true &&
                <Modaladdcustos
                    list={list}
                    flag_open_modal={flag_open_modal_aux}
                    set_flag_open_modal={set_flag_open_modal_aux}
                    setMessage={setMessage}
                    setOpenSnackSuccess={setOpenSnackSuccess}
                    setOpenSnackError={setOpenSnackError}
                    set_list={set_list}
                    flag_open_modal_ver_mais={flag_open_modal_ver_mais}
                    set_flag_open_modal_ver_mais={set_flag_open_modal_ver_mais}
                    flag_open_modal_edit={flag_open_modal_edit}
                    set_flag_open_modal_edit={set_flag_open_modal_edit}
                    flag_open_modal_add={flag_open_modal_add}
                    set_flag_open_modal_add={set_flag_open_modal_add}
                    set_obj_new={set_obj_new}
                    obj_new={obj_new}
                    obj_financeiro={obj_financeiro}
                    set_obj_new_financeiro={set_obj_new_financeiro}

                />
            }

            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col w-full flex-1 overflow-auto">
                            <div className="w-full p-5 flex justify-start">
                                <button
                                    type="button"
                                    onClick={() => {
                                        set_flag_open_modal_aux(true);
                                        set_flag_open_modal_edit(false);
                                        set_flag_open_modal_add(true);
                                        set_flag_open_modal_ver_mais(false);
                                        set_obj_new(undefined);
                                    }}
                                    className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                >
                                    <AddIcon sx={{ fontSize: 18 }} />
                                    Adicionar Registo de Custos
                                </button>
                            </div>

                            <div className="flex flex-col w-full flex-1 overflow-auto px-5 pb-5">
                                {list.length > 0 ? (
                                    <div className="w-full">
                                        <div className="text-sm font-semibold text-gray-500 mb-3">
                                            Registos de Custos
                                        </div>

                                        <div className="grid grid-cols-[repeat(auto-fill,minmax(180px,1fr))] gap-4">

                                            {list.map((custos, index) => {
                                                const isSelected = obj_new?.id_custo === custos.id_custo;
                                                const isHovered = hover.flag && hover.id === custos.id_custo;

                                                return (
                                                    <div
                                                        key={index}
                                                        className={`
                                                        flex flex-col items-center justify-center w-[180px] min-w-[180px] w-full max-w-[250px] p-4 rounded-xl cursor-pointer
                                                        transition-all duration-200
                                                        ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                                                        ${isHovered ? 'shadow-md' : 'shadow-sm'}
                                                      `}
                                                        onMouseEnter={() => setHover({ flag: true, id: custos.id_custo })}
                                                        onMouseLeave={() => setHover({ flag: false, id: custos.id_custo })}

                                                        onClick={() => {
                                                            set_flag_open_modal_aux(true)
                                                            set_obj_new(custos)
                                                            set_flag_open_modal_ver_mais(true)
                                                            set_flag_open_modal_edit(false)
                                                            set_flag_open_modal_add(false)
                                                        }}
                                                    >
                                                        <div className="space-y-2 text-sm w-full">
                                                            <div className="flex items-center justify-between gap-3">
                                                                <span className="text-gray-500">Categoria</span>
                                                                <span className="text-gray-800 font-medium truncate">
                                                                    {custos.categoria || '-'}
                                                                </span>
                                                            </div>

                                                            <div className="flex items-center justify-between gap-3">
                                                                <span className="text-gray-500">Descrição</span>
                                                                <span className="text-gray-800 font-medium truncate">
                                                                    {custos.descricao || '-'}
                                                                </span>
                                                            </div>

                                                            <div className="flex items-center justify-between gap-3">
                                                                <span className="text-gray-500">Data</span>
                                                                <span className="text-gray-800 font-medium truncate">
                                                                    {custos.data_realizada || custos.data_prevista || '-'}
                                                                </span>
                                                            </div>

                                                            <div className="flex items-center justify-between gap-3">
                                                                <span className="text-gray-500">Estado</span>
                                                                <span className="text-gray-800 font-medium truncate">
                                                                    {custos.estado || '-'}
                                                                </span>
                                                            </div>
                                                            <div
                                                                className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                                            />
                                                        </div>


                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="w-full rounded-xl border border-dashed border-gray-300 bg-gray-50 px-4 py-8 text-center text-sm text-gray-400">
                                        Não existem registos de custos.
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
            }


        </div>



    </Modal>)

}
